import { useAnlageassistentFormContext } from '@/domain/mitarbeiter/features/anlageassistent/context/AnlageassistentFormContext';
import { useTranslation } from 'react-i18next';

// oxlint-disable-next-line max-lines-per-function
export function Auszahlungsgrenze() {
  const { t } = useTranslation();
  const form = useAnlageassistentFormContext();
  return (
    <form.Subscribe
      selector={(state) => ({
        auszahlungsgrenzeEinheit:
          state.values.bezahlung.arbeitszeitkonto.stundenloehner
            .auszahlungsgrenzeEinheit,
      })}>
      {({ auszahlungsgrenzeEinheit }) => (
        <>
          {auszahlungsgrenzeEinheit === 'euro' && (
            <div className="flex flex-col gap-6">
              <div className="flex flex-col gap-3">
                <span className="text-neutrals-900 text-base font-bold leading-6">
                  {t(
                    'domain.mitarbeiter.create.steps.bezahlung.sollstunden.form.auszahlungsgrenzeEuro.title',
                  )}
                </span>
                <span className="text-neutrals-800 text-sm font-normal leading-5">
                  {t(
                    'domain.mitarbeiter.create.steps.bezahlung.sollstunden.form.auszahlungsgrenzeEuro.description',
                  )}
                </span>
              </div>
              <div className="grid lg:grid-cols-2">
                <form.AppField name="bezahlung.arbeitszeitkonto.stundenloehner.auszahlungsgrenzeEuro">
                  {(field) => (
                    <field.MoneyInput
                      label={t(
                        'domain.mitarbeiter.create.steps.bezahlung.sollstunden.form.auszahlungsgrenzeEuro.label',
                      )}
                      isRequired
                    />
                  )}
                </form.AppField>
              </div>
            </div>
          )}
          {auszahlungsgrenzeEinheit === 'stunden' && (
            <div className="flex flex-col gap-6">
              <div className="flex flex-col gap-3">
                <span className="text-neutrals-900 text-base font-bold leading-6">
                  {t(
                    'domain.mitarbeiter.create.steps.bezahlung.sollstunden.form.auszahlungsgrenzeStunden.title',
                  )}
                </span>
                <span className="text-neutrals-800 text-sm font-normal leading-5">
                  {t(
                    'domain.mitarbeiter.create.steps.bezahlung.sollstunden.form.auszahlungsgrenzeStunden.description',
                  )}
                </span>
              </div>
              <div className="grid lg:grid-cols-2">
                <form.AppField name="bezahlung.arbeitszeitkonto.stundenloehner.auszahlungsgrenzeStunden">
                  {(field) => (
                    <field.HoursInput
                      label={t(
                        'domain.mitarbeiter.create.steps.bezahlung.sollstunden.form.auszahlungsgrenzeStunden.label',
                      )}
                      placeholder="hh:mm"
                      isRequired
                      suffix={t(
                        'domain.mitarbeiter.create.steps.bezahlung.sollstunden.form.auszahlungsgrenzeStunden.suffix',
                      )}
                    />
                  )}
                </form.AppField>
              </div>
            </div>
          )}
        </>
      )}
    </form.Subscribe>
  );
}
